import { canvasBaseColor, canvasHoverColor } from '@edulastic/colors'
import styled from 'styled-components'
import { Button } from 'antd'

/** @type {typeof Button} */
export const AuthorizeCanvasBtn = styled(Button)`
  color: ${canvasBaseColor} !important;
  border: ${({ borderColor }) =>
    borderColor ? `1px solid ${borderColor}` : 'none'} !important;
  font-size: ${({ fontSize }) => fontSize || '14px'};
  font-weight: 600;
  margin-top: 10px;
  display: flex;
  gap: 4px;
  align-items: center;

  &:hover {
    color: ${canvasHoverColor} !important;
    svg {
      g {
        path {
          fill: ${canvasHoverColor} !important;
        }
      }
    }
  }
`
